import { Button } from '@/components/ui/button';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CollisionPriority } from '@dnd-kit/abstract';
import { useSortable } from '@dnd-kit/react/sortable';
import { GripVertical } from 'lucide-react';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  id: string;
  index: number;
  name: string;
  isCollapsed: boolean;
}

export function AccountSortGroup({ children, id, index, name, isCollapsed }: Props) {
  const { handleRef, ref } = useSortable({
    id,
    index,
    type: 'group',
    collisionPriority: CollisionPriority.Low,
    accept: ['account', 'group'],
  });

  return (
    <div ref={ref} className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="font-semibold bg-accent w-full">
              <div className="flex items-center justify-between pl-2 font-bold">
                <span>{name}</span>
                <Button
                  ref={handleRef}
                  variant="outline"
                  size="icon"
                  className="h-6 w-6 cursor-grab active:cursor-grabbing"
                >
                  <GripVertical className="h-4 w-4" />
                </Button>
              </div>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>{!isCollapsed && children}</TableBody>
      </Table>
    </div>
  );
}
